import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import GeneralTables from "components/Common/GeneralTable"
import { isNull } from "lodash"
import React from "react"
import { Card, CardBody } from "reactstrap"

const ProviderChartInItemsList = ({ data, loading, type, totalQuantity, pagination }) => {
  let total = 0

  if (type === "balance") {
    total =
      totalQuantity ??
      data?.reduce(
        (curr, obj) => curr + ((obj.flow_quantity ?? obj.in_qty_per_ip) || 0),
        0
      )
  } else {
    total =
      totalQuantity ??
      data?.reduce((curr, obj) => curr + (obj.first_in_qty_per_ip || 0), 0)
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          {/*
              CustomHeaderTitle Component Props:
              
              - loading: Boolean flag to display loading state
              - title: String to display as the header title
              - rowCount: Boolean to show/hide the row number selector
              - lgColumn: Number to control the width of columns based on layout needs
              - onChangeRowNumber: Callback function to handle row number selection change
              - orderingList: Boolean to show/hide ordering dropdown
              - onChangeOrdering: Callback function triggered when the ordering option is changed
              - searchBox: Boolean to show/hide search input box
              - onSearchHandler: Function called on key up in the search box
              - rightBtn: Boolean to show/hide right-side button (for example, a back button)
              - rightBtnTitle: String for setting the right button's label
              - rightBtnRoute: Route for the right button's navigation
              - exportBtn: Boolean to show/hide export button
              - onExportBtnClick: Callback for when the export button is clicked
              - exportBtnLoading: Boolean flag to show loading state during export functionality
              - advnacedSearchBtn: Boolean to show/hide advanced search button
              - advnacedSearchBtnTitle: String to display the advanced search button label
              - onAdvancedSearch: Callback function when the advanced search button is clicked (used to toggle collapse)
              - orderingOptions: Array of options to populate the ordering dropdown (value and name pair)
            */}
          <CustomHeaderTitle
            loading={loading}
            title={`Provider ${type === "balance" ? "Balance" : "Receipts"}`}
            lgColumn={4}
            rowCount={false}
            orderingList={false}
            searchBox={false}
            rightBtn={true}
            rightBtnTitle={"Back"}
            rightBtnRoute={"/dashboard"}
          />

          {/*
            GeneralTables Component Props:

            - data: Array containing the data to be displayed in the table
            - loading: Boolean indicating the loading state of the table
            - parentCheckbox: Boolean to determine if a parent checkbox is included in the table
            - headers: Array of strings representing the column headers for the table
            - pagination: Object containing pagination metadata and a callback function:
                - meta: Object for pagination details (e.g., page number, total items)
                - onPageClick: Callback function to handle page number changes
            - renderItem: Function to render each row/item in the table using the provided data
          */}
          <GeneralTables
            data={data}
            loading={loading}
            pagination={pagination}
            headers={[
              "#",
              "UNFPA ITEM ID",
              "IP-ITEM DESCRIPTION",

              "BATCH NUMBER",
              "EXPIRE DATE",
              "QUANTITY",
              "RECEIPTS DATE",
            ]}
            renderItem={(ins, index) => {
              const exchange_qty = isNull(ins?.exchange_qty)
                ? 0
                : ins?.exchange_qty
              return (
                <tr key={index}>
                  <th scope="row">{index + 1}</th>
                  <td>{ins.item?.unfp_item_name}</td>
                  <td>{ins.item?.ip_item_description}</td>
                  <td>{ins.batch_number}</td>
                  <td>{ins.expire_date}</td>
                  <td>
                    {type === "balance"
                      ? (ins.flow_quantity ?? ins.in_qty_per_ip)
                      : ins.first_in_qty_per_ip}
                  </td>
                  <td>{ins.date}</td>
                </tr>
              )
            }}
          />
          <br />

          <div style={{ textAlign: "center", fontSize: 18, fontWeight: 500 }}>
            <p>Total: {total}</p>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default ProviderChartInItemsList
